import { observer } from 'mobx-react'
import './index.scss'
import { ReactComponent as Plus } from '../../../../assets/footer/plus.svg'
import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { useLocation, useNavigate } from 'react-router'
import { changeCoopState } from '../../../../stores/GlobalState'
import { runInAction } from 'mobx'
import { FormState } from '../Arrange'
const Support = observer(
  ({ content, linkblock }: { content: any; linkblock: string }) => {
    const { pathname } = useLocation()
    const navigate = useNavigate()
    return (
      <section className={classNames('things-support')}>
        <div className="things-support__content">
          <div className="things-support__title">{content.title}</div>
          <div className="things-support__list">
            {content.list.map((li: any, i: number) => (
              <SupportItem key={i} li={li} />
            ))}
          </div>
        </div>
        {content.buttonTitle.length ? (
          <>
            {content.buttonLink.includes('#coop') ? (
              <div
                className="button black"
                onClick={() => {
                  if (
                    [
                      "freight",
                      "mizhnarodnyi-khab",
                      "end2end-dostavka",
                    ].includes(
                      linkblock
                        .replaceAll("/for-you/", "")
                        .replaceAll("/for-business/", "")
                    )
                  ) {
                    runInAction(() => {
                      FormState.link = linkblock
                        .replaceAll("/for-you/", "")
                        .replaceAll("/for-business/", "");
                    });
                  }
                  changeCoopState()
                }}
              >
                {content.buttonTitle}
              </div>
            ) : (
              <a className="button black" href={content.buttonLink}>
                {content.buttonTitle}
              </a>
            )}
          </>
        ) : (
          <></>
        )}
      </section>
    )
  },
)

export default Support

const SupportItem = observer(({ li }: { li: any }) => {
  const [active, setActive] = useState(false)
  const ref = useRef<any>(null)
  useEffect(() => {
    if (!ref.current || !li) return
    ref.current.style.setProperty(
      '--support-height',
      ref.current.scrollHeight + 'px',
    )
  })

  return (
    <div
      className={classNames('things-support__item', active && 'active')}
      onClick={() => setActive(!active)}
    >
      <div className="things-support__item-top">
        <div className="things-support__item-icon">
          <img src={li.icon} />
        </div>
        <div className="things-support__item-title">{li.title}</div>
        <div className="things-support__item-close">
          <Plus />
        </div>
      </div>

      <div className="things-support__item-col" ref={ref}>
        <div
          className="things-support__item-text"
          dangerouslySetInnerHTML={{ __html: li.text }}
        ></div>
      </div>
    </div>
  )
})
